/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Deliver_Title7Inputs */

const en_svc_automation_deliver_title7 = /** @type {(inputs: Svc_Automation_Deliver_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data movement & delivery`)
};

const ar_svc_automation_deliver_title7 = /** @type {(inputs: Svc_Automation_Deliver_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نقل البيانات وتسليمها`)
};

const bn_svc_automation_deliver_title7 = /** @type {(inputs: Svc_Automation_Deliver_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেটা মোভমেন্ট ও ডেলিভারি`)
};

const de_svc_automation_deliver_title7 = /** @type {(inputs: Svc_Automation_Deliver_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenbewegung und -bereitstellung`)
};

const es_svc_automation_deliver_title7 = /** @type {(inputs: Svc_Automation_Deliver_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movimiento y entrega de datos`)
};

const fr_svc_automation_deliver_title7 = /** @type {(inputs: Svc_Automation_Deliver_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mouvement et livraison des données`)
};

const pt_svc_automation_deliver_title7 = /** @type {(inputs: Svc_Automation_Deliver_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movimentação e entrega de dados`)
};

const zh_svc_automation_deliver_title7 = /** @type {(inputs: Svc_Automation_Deliver_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据移动和交付`)
};

const tr_svc_automation_deliver_title7 = /** @type {(inputs: Svc_Automation_Deliver_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veri taşıma ve teslimi`)
};

const ru_svc_automation_deliver_title7 = /** @type {(inputs: Svc_Automation_Deliver_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перемещение и доставка данных`)
};

const pl_svc_automation_deliver_title7 = /** @type {(inputs: Svc_Automation_Deliver_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przenoszenie i dostarczanie danych`)
};

/**
* | output |
* | --- |
* | "Data movement & delivery" |
*
* @param {Svc_Automation_Deliver_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_deliver_title7 = /** @type {((inputs?: Svc_Automation_Deliver_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Deliver_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_deliver_title7(inputs)
	if (locale === "bn") return bn_svc_automation_deliver_title7(inputs)
	if (locale === "de") return de_svc_automation_deliver_title7(inputs)
	if (locale === "es") return es_svc_automation_deliver_title7(inputs)
	if (locale === "fr") return fr_svc_automation_deliver_title7(inputs)
	if (locale === "pt") return pt_svc_automation_deliver_title7(inputs)
	if (locale === "zh") return zh_svc_automation_deliver_title7(inputs)
	if (locale === "tr") return tr_svc_automation_deliver_title7(inputs)
	if (locale === "ru") return ru_svc_automation_deliver_title7(inputs)
	if (locale === "pl") return pl_svc_automation_deliver_title7(inputs)
	return en_svc_automation_deliver_title7(inputs)
});
export { svc_automation_deliver_title7 as "svc_automation_DELIVER_title" }